const baseUrl = 'https://msheets.net/';

export default {
	baseUrl: baseUrl,
};
